import * as Yup from 'yup'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useCallback } from 'react'
import { useSnackbar } from 'notistack'
import { useNavigate } from 'react-router-dom'
import { Form, FormikProvider, useFormik } from 'formik'
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs.js'
import { KeyboardBackspaceOutlined } from '@material-ui/icons'
import Page from 'src/components/Page.js'
// material
import { LoadingButton } from '@material-ui/lab'
import { Autocomplete, Checkbox } from '@material-ui/core'
import {
  Box,
  Button,
  Card,
  Grid,
  Stack,
  Switch,
  TextField,
  Typography,
  FormHelperText,
  Container,
  FormControlLabel,
} from '@material-ui/core'
import { Block } from 'src/pages/components-overview/Block.js'
// utils
import fakeRequest from 'src/utils/fakeRequest.js'
// routes
import { PATH_DASHBOARD } from 'src/routes/paths.js'
import { Link as RouterLink } from 'react-router-dom'
//
import Label from 'src/components/Label.js'
import axios from 'axios'
import { COMPANY_NAME, REST_API_END_POINT } from 'src/constants/Defaultvalues'
import UserRoleList from 'src/pages/dashboard/UserRoleList'

// ----------------------------------------------------------------------

export default function ClientUserRoleAdd() {
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const [checkedCheckboxIds, setCheckedCheckboxIds] = useState([])
  const [permissionState, setPermissionState] = useState([])

  const user = JSON.parse(localStorage.getItem('user'))
  const userId = user.user_id
  const userType = user.user_type

  const handleback = () => {
    window.history.back()
  }

  const NewUserSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
  })

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: '',
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        console.log('Add user role - added name -- ', values.name)
        console.log('Add user role checkedCheckboxIds -- ', checkedCheckboxIds)
        if (checkedCheckboxIds.length > 0) {
          const permission = checkedCheckboxIds.join(',')
          console.log('permissionpermission==', permission)
          const response = await axios.post(
            `${REST_API_END_POINT}settings/add-user-role`,
            { name: values.name, userId: userId, permissions: permission,isClientUserRole:true },
          )
          if (response.data.status === 1) {
            enqueueSnackbar(response.data.message, { variant: 'success' })
            resetForm()
            navigate(PATH_DASHBOARD.client.userRoles, {
              state: { data: permission },
            })
          } else if (response.data.status === 0 || response.data.status === 2) {
            enqueueSnackbar(response.data.message, { variant: 'error' })
          } else {
            enqueueSnackbar('Server Error', { variant: 'error' })
          }
        } else {
          enqueueSnackbar('Please select atleast 1 user permission', {
            variant: 'error',
          })
        }
      } catch (error) {
        console.error('formik error - ', error)
        setSubmitting(false)
        setErrors(error)
      }
    },
  })

  const {
    errors,
    values,
    touched,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    getFieldProps,
  } = formik

  const formatPermissions = (rawPermissions) => {
    const grouped = {}

    Object.keys(rawPermissions).forEach((module) => {
      const modulePerms = rawPermissions[module]

      const parentMap = modulePerms.reduce((acc, perm) => {
        if (!perm.parent_id) {
          acc[perm.id] = { ...perm, children: [] }
        }
        return acc
      }, {})

      modulePerms.forEach((perm) => {
        if (perm.parent_id && parentMap[perm.parent_id]) {
          parentMap[perm.parent_id].children.push({ ...perm })
        }
      })

      grouped[module] = Object.values(parentMap)
    })

    return grouped
  }

const fetchData = async () => {
  try {
    const response = await axios.post(`${REST_API_END_POINT}settings/get-all-settings`, {
      userId,
      userType,
    });

    const data = response.data.results;

    const allowedModules = [
      'Request',
      'Projects',
      'Estimate',
      'Design Order',
      'Production Control Board',
      'Settings',
      'Payments',
      'Sign agreements',
      'Calendar',
      'Calls',
      'SMS',
      'Customer Orders',
      'Team Members',
      'Onboarding',
      'User Roles',
    ];

    const filteredPermissions = Object.entries(data.permissions).reduce((acc, [moduleName, perms]) => {
      if (allowedModules.includes(moduleName)) {
        const clientPerms = perms.filter((perm) => perm.for_client_user_role === 1);
        if (clientPerms.length > 0) {
          acc[moduleName] = clientPerms;
        }
      }
      return acc;
    }, {});

    const formatted = formatPermissions(filteredPermissions);
    setPermissionState(formatted);
  } catch (error) {
    console.error('Error:', error);
  }
};


  useEffect(() => {
    fetchData()
  }, [])

  const handleCheckboxToggle = (moduleName, index) => {
    const updatedState = { ...permissionState }
    const target = updatedState[moduleName][index]
    const isChecked = !target.checked
    target.checked = isChecked
    if (target.children) {
      target.children = target.children.map((child) => ({
        ...child,
        checked: isChecked,
      }))
    }
    setPermissionState(updatedState)
    updateCheckedIds(updatedState)
  }

  const handleChildCheckboxToggle = (moduleName, parentIndex, childIndex) => {
    const updatedState = { ...permissionState }
    const parentItem = updatedState[moduleName][parentIndex]
    const childItem = parentItem.children[childIndex]

    // Toggle child
    childItem.checked = !childItem.checked

    // Update parent based on children
    const allChildrenChecked = parentItem.children.every((c) => c.checked)
    const someChildrenChecked = parentItem.children.some((c) => c.checked)

    parentItem.checked = allChildrenChecked
    parentItem.indeterminate = !allChildrenChecked && someChildrenChecked

    setPermissionState(updatedState)
    updateCheckedIds(updatedState)
  }

  const updateCheckedIds = (updatedState) => {
    const updatedIds = Object.values(updatedState).flatMap((items) =>
      items.flatMap((item) => [
        ...(item.checked ? [item.id] : []),
        ...(item.children
          ? item.children.filter((c) => c.checked).map((c) => c.id)
          : []),
      ]),
    )
    setCheckedCheckboxIds(updatedIds)
  }

  const getParentCheckboxState = (item) => {
    if (!item.children || item.children.length === 0) {
      return {
        checked: item.checked || false,
        indeterminate: false
      };
    }
  
    const checkedStates = item.children.map(c => c.checked);
    const allChecked = checkedStates.every(Boolean);
    const someChecked = checkedStates.some(Boolean) && !allChecked;
  
    return {
      checked: allChecked,
      indeterminate: someChecked
    };
  };
  

  return (
    <Page title={`Add Client User Role | ${COMPANY_NAME}`}>
      <Container>
        <HeaderBreadcrumbs heading="Add Client User Role" />
        <Box
          sx={{
            mt: 3,
            display: 'flex',
            justifyContent: 'flex-end',
            paddingBottom: 2,
            marginBottom: 2,
          }}
        >
          <Button
            variant="outlined"
            type="submit"
            onClick={() => handleback()}
            sx={{ alignItems: 'right' }}
            startIcon={
              <Stack>
                <KeyboardBackspaceOutlined />
              </Stack>
            }
          >
            Back
          </Button>
        </Box>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={10}>
                <Stack spacing={3}>
                  <Stack
                    justifyContent="space-between"
                    direction={{ xs: 'column', sm: 'column' }}
                  >
                    <Stack
                      direction={{ xs: 'column', sm: 'row' }}
                      spacing={{ xs: 3, sm: 2 }}
                      sx={{ mb: 4 }}
                    >
                      <TextField
                        fullWidth
                        label="Name"
                        type="text"
                        {...getFieldProps('name')}
                        error={Boolean(touched.name && errors.name)}
                        helperText={touched.name && errors.name}
                      />
                    </Stack>
                    {/* {console.log('permissionState --- ', permissionState)} */}
                    {permissionState &&
                      Object.entries(permissionState).map(
                        ([moduleName, moduleData], index) => {
                          const allChecked = moduleData.every(
                            (item) => item.checked,
                          )
                          const someChecked = moduleData.some(
                            (item) => item.checked,
                          )
                          return (
                            <Stack key={index} spacing={{ xs: 2, sm: 1 }}>
                              <Stack>
                                <FormControlLabel
                                  label={
                                    moduleName === 'Request'
                                      ? 'Sales Order'
                                      : moduleName === 'Jobs'
                                      ? 'Production'
                                      : moduleName === 'Receive Inventory'
                                      ? 'Purchase Order'
                                      : moduleName
                                  }
                                  control={
                                    <Checkbox
                                      checked={allChecked}
                                      indeterminate={someChecked && !allChecked}
                                      onChange={() => {
                                        const updatedState = {
                                          ...permissionState,
                                          [moduleName]: permissionState[
                                            moduleName
                                          ].map((item) => ({
                                            ...item,
                                            checked: !allChecked,
                                          })),
                                        }
                                        setPermissionState(updatedState)
                                        const updatedIds = Object.entries(
                                          updatedState,
                                        ).flatMap(([module, items]) =>
                                          items
                                            .filter((item) => item.checked)
                                            .map((item) => item.id),
                                        )
                                        setCheckedCheckboxIds(updatedIds)
                                      }}
                                    />
                                  }
                                />
                                {moduleData.map((item, optionIndex) => {
                                  const { checked: parentChecked, indeterminate: parentIndeterminate } = getParentCheckboxState(item);

                                  return (
                                    <React.Fragment key={optionIndex}>
                                      <FormControlLabel
                                        sx={{ marginLeft: '40px' }}
                                        label={item.name
                                          .replace(/request/gi, 'Sales Order')
                                          .replace(
                                            /Design Order Jobs?/gi,
                                            'Design Jobs',
                                          )}
                                        control={
                                          <Checkbox
                                            checked={parentChecked}
                                            indeterminate={parentIndeterminate}
                                            onChange={() =>
                                              handleCheckboxToggle(
                                                moduleName,
                                                optionIndex,
                                              )
                                            }
                                            // onChange={() => {
                                            //   const updatedState = {
                                            //     ...permissionState,
                                            //     [moduleName]: permissionState[
                                            //       moduleName
                                            //     ].map((currentItem, j) => {
                                            //       if (j === optionIndex) {
                                            //         return {
                                            //           ...currentItem,
                                            //           checked: !currentItem.checked,
                                            //         }
                                            //       }
                                            //       return currentItem
                                            //     }),
                                            //   }
                                            //   setPermissionState(updatedState)

                                            //   const updatedIds = Object.entries(
                                            //     updatedState,
                                            //   ).flatMap(([module, items]) =>
                                            //     items
                                            //       .filter((item) => item.checked)
                                            //       .map((item) => item.id),
                                            //   )
                                            //   setCheckedCheckboxIds(updatedIds)
                                            // }}
                                          />
                                        }
                                      />
                                      {item.children &&
                                        item.children.map(
                                          (child, childIndex) => (
                                            <FormControlLabel
                                              key={`child-${childIndex}`}
                                              sx={{ marginLeft: '80px' }}
                                              label={child.name}
                                              control={
                                                <Checkbox
                                                  checked={
                                                    child.checked || false
                                                  }
                                                  onChange={() =>
                                                    handleChildCheckboxToggle(
                                                      moduleName,
                                                      optionIndex,
                                                      childIndex,
                                                    )
                                                  }
                                                />
                                              }
                                            />
                                          ),
                                        )}
                                    </React.Fragment>
                                  )
                                })}
                              </Stack>
                            </Stack>
                          )
                        },
                      )}
                  </Stack>
                </Stack>

                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
                  <LoadingButton
                    type="submit"
                    variant="contained"
                    loading={isSubmitting}
                  >
                    Save Changes
                  </LoadingButton>
                  <Button
                    variant="outlined"
                    // component={RouterLink}
                    // to={PATH_DASHBOARD.adminAccount.root}
                    onClick={() => window.history.back()}
                    sx={{ marginLeft: '10px' }}
                  >
                    Cancel
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </Container>
    </Page>
  )
}
